import React from "react";
import { useTranslation } from "react-i18next";
import SectionComponent from "../../../../components/utils/SectionComponent";
import "./financialList.scss";

function FinancialList() {
  const { t } = useTranslation()
  return (
    <div className="container-financial-list">
      <div className="texts-financial-list">
        <SectionComponent title={t("education.financial_list.financial.title")} text={t("education.financial_list.financial.section_text_1")}>
          <p>{t("education.financial_list.financial.section_text_2")}</p>
          <p>{t("education.financial_list.financial.section_text_3")}</p>
        </SectionComponent>


        <SectionComponent title={t("education.financial_list.register.title")} text={t("education.financial_list.register.section_text_1")}>
          <p>{t("education.financial_list.register.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("education.financial_list.student_allocation.title")} text={t("education.financial_list.student_allocation.section_text_1")}>
          <p>{t("education.financial_list.student_allocation.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("education.financial_list.history.title")} text={t("education.financial_list.history.section_text_1")}>
          <p>{t("education.financial_list.history.section_text_2")}</p>
        </SectionComponent>
      </div>
    </div>
  );
}

export default FinancialList;
